// P2P-3116: иконки страницы alfa_page - из прототипа ТЗ (контурные, цвет берут от текста).
type IconProps = { className?: string };

const strokeProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  'aria-hidden': true,
} as const;

export const DownloadQrIcon = ({ className }: IconProps) => (
  <svg {...strokeProps} className={className}>
    <path d="M12 3v12m0 0-5-5m5 5 5-5M5 21h14" />
  </svg>
);

export const CheckMarkIcon = ({ className }: IconProps) => (
  <svg {...strokeProps} strokeWidth={3} className={className}>
    <path d="m5 12 5 5 9-10" />
  </svg>
);

export const ScanIcon = ({ className }: IconProps) => (
  <svg {...strokeProps} className={className}>
    <path d="M4 8V5a1 1 0 0 1 1-1h3M16 4h3a1 1 0 0 1 1 1v3M20 16v3a1 1 0 0 1-1 1h-3M8 20H5a1 1 0 0 1-1-1v-3" />
    <path d="M9 9h2v2H9zM13 13h2v2h-2z" />
  </svg>
);

export const GalleryIcon = ({ className }: IconProps) => (
  <svg {...strokeProps} className={className}>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <circle cx="9" cy="10" r="2" />
    <path d="m21 16-5-5-9 9" />
  </svg>
);

export const CopyFieldIcon = ({ className }: IconProps) => (
  <svg {...strokeProps} className={className}>
    <rect x="9" y="9" width="11" height="11" rx="2" />
    <path d="M5 15V5a2 2 0 0 1 2-2h10" />
  </svg>
);

export const WarnIcon = ({ className }: IconProps) => (
  <svg {...strokeProps} className={className}>
    <path d="M12 3 2 21h20L12 3z" />
    <path d="M12 10v4M12 17.5v.5" />
  </svg>
);

export const ChevronDownIcon = ({ className }: IconProps) => (
  <svg {...strokeProps} className={className}>
    <path d="m6 9 6 6 6-6" />
  </svg>
);

export const TimerIcon = ({ className }: IconProps) => (
  <svg {...strokeProps} strokeWidth={2.4} className={className}>
    <circle cx="12" cy="13" r="8" />
    <path d="M12 9v4l2 2" />
  </svg>
);

// Мини-макет меню «Поделиться» iOS на первом слайде.
export const SaveImageIcon = ({ className }: IconProps) => (
  <svg {...strokeProps} className={className}>
    <path d="M12 4v11m0 0-4-4m4 4 4-4" />
    <path d="M5 14v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4" />
  </svg>
);

export const CopyActionIcon = ({ className }: IconProps) => (
  <svg {...strokeProps} className={className}>
    <rect x="8" y="8" width="11" height="12" rx="2" />
    <path d="M5 16V6a2 2 0 0 1 2-2h8" />
  </svg>
);

export const MoreIcon = ({ className }: IconProps) => (
  <svg {...strokeProps} strokeWidth={2.4} className={className}>
    <path d="m6 9 6 6 6-6" />
  </svg>
);
